export const durations = { fast: 150, normal: 300, slow: 500 } as const;
